import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/api/profile.service';
import { CustomerSupportContactDetails } from 'src/app/models/user';

@Component({
  selector: 'contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss']
})
export class ContactCardComponent implements OnInit {

  constructor(private profileService: ProfileService) { }

  vip: boolean;
  contactDetails: CustomerSupportContactDetails;

  ngOnInit() {
    this.getProfile();
  }

  getProfile() {
    this.profileService.get().subscribe(response => {
      this.vip = response.vip;
      this.contactDetails = response.customerSupportContactDetails;
    });
  }

}
